/* SearchItem.styles.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["as", "style"],
  _excluded7 = ["as", "style"],
  _excluded8 = ["as", "style"],
  _excluded9 = ["as", "style"],
  _excluded10 = ["as", "style"],
  _excluded11 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _56 = "._syazaqb7{color:var(--ds-text-selected,#0c66e4)}";
const _55 = "._1e0c1o8l{display:inline-block}";
const _54 = "._vwz41k8s{line-height:1.5rem}";
const _53 = "._zg8l4jg8{font-style:normal}";
const _52 = "._1wyb1j6v{font-size:1rem}";
const _51 = "._ect418aq{font-family:var(--ds-font-family-brand-body,\"Charlie Text\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _50 = "._k48p1nn1{font-weight:400}";
const _49 = "._syaz1fxt{color:var(--ds-text,#172b4d)}";
const _48 = "._1bsbyh40{width:2px}";
const _47 = "._94n5idpf{bottom:0}";
const _46 = "._154iidpf{top:0}";
const _45 = "._1ltvidpf{left:0}";
const _44 = "._kqswstnw{position:absolute}";
const _43 = "._11q71yqz{background:var(--ds-border-selected,#0c66e4)}";
const _42 = "@media (min-width:64rem){._wrkn166n[aria-selected=true]{background:var(--ds-background-neutral-subtle-hovered,#091e420f)}._1rdt1ule[aria-selected=true] .selected-marker{display:block}._41ybewfl[aria-selected=true] .suggestion-arrow-icon{visibility:visible}._fkkaewfl:active .suggestion-arrow-icon{visibility:visible}}";
const _41 = "._1vdzneh2:active{border-left:2px solid var(--ds-border-selected,#0c66e4)}";
const _40 = "._1lg6glyw .selected-marker{display:none}";
const _39 = "._kqswh2mm{position:relative}";
const _38 = "._1ul9idpf{min-width:0}";
const _37 = "@media (min-width:64rem){._1yaguwho{padding:0 var(--ds-space-250,20px) 0 var(--ds-space-300,24px)}._165t1ylp{height:40px}._1wapewfl:focus-visible:not(:active) .suggestion-arrow-icon{visibility:visible}}";
const _36 = "._x5dbugt7:focus-visible:not(:active){outline:2px solid var(--ds-border-focused,#388bff)}";
const _35 = "._1bsb1osq{width:100%}";
const _34 = "._1bah1yb4{justify-content:space-between}";
const _33 = "._1yt4vc9x{padding:0 var(--ds-space-050,4px) 0 var(--ds-space-300,24px)}";
const _32 = "._o5721q9c{white-space:nowrap}";
const _31 = "._1bto1l2s{text-overflow:ellipsis}";
const _30 = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const _29 = "._18m915vq{overflow-y:hidden}";
const _28 = "._1reo15vq{overflow-x:hidden}";
const _27 = "@media (min-width:64rem){._w14j15vq{visibility:hidden}._dm251ule{display:block}}";
const _26 = "._1e0cglyw{display:none}";
const _25 = "._19pk1b66{margin-top:var(--ds-space-050,4px)}";
const _24 = "._4t3i7vkz{height:1pc}";
const _23 = "._1bsb7vkz{width:1pc}";
const _22 = "@media not all and (min-width:64rem){._1j6pugt7:focus-visible:not(:active){outline:2px solid var(--ds-border-focused,#388bff)}}";
const _21 = "@media (min-width:64rem){._dm25glyw{display:none}}";
const _20 = "._j6xt1dty:active{background:var(--ds-background-neutral-subtle-pressed,#091e4224)}";
const _19 = "._80omtlke{cursor:pointer}";
const _18 = "._1o9zidpf{flex-shrink:0}";
const _17 = "._4t3ickbl{height:3pc}";
const _16 = "._1bsbt9kd{width:72px}";
const _15 = "._11q7glyw{background:none}";
const _14 = "._18u0idpf{margin-left:0}";
const _13 = "._otyridpf{margin-bottom:0}";
const _12 = "._2hwxidpf{margin-right:0}";
const _11 = "._19pkidpf{margin-top:0}";
const _10 = "._19itglyw{border:none}";
const _9 = "._4t3i1tcg{height:24px}";
const _8 = "._1bsb1tcg{width:24px}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives/responsive';
import { ellipsisCompiled } from '@atlassian/mpac-ui/theme';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _7 = "._4cvr1h6o{align-items:center}";
const _6 = "._1bah1h6o{justify-content:center}";
const _5 = "._1e0c1txw{display:flex}";
const _4 = "._19bvidpf{padding-left:0}";
const _3 = "._n3tdidpf{padding-bottom:0}";
const _2 = "._u5f3idpf{padding-right:0}";
const _ = "._ca0qidpf{padding-top:0}";
export const ParentContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "li",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _1bah1h6o _4cvr1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ParentContainer.displayName = 'ParentContainer';
}
export const Icon24 = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "img",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_8, _9]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb1tcg _4t3i1tcg", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Icon24.displayName = 'Icon24';
}
export const AppendButton = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "button",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_10, _11, _12, _13, _14, _, _2, _3, _4, _15, _16, _17, _18, _19, _5, _6, _7, _20, _21, _22]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19itglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7glyw _1bsbt9kd _4t3ickbl _1o9zidpf _80omtlke _1e0c1txw _1bah1h6o _4cvr1h6o _j6xt1dty _dm25glyw _1j6pugt7", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AppendButton.displayName = 'AppendButton';
}
export const Icon16 = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "img",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_23, _24, _25]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb7vkz _4t3i7vkz _19pk1b66", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Icon16.displayName = 'Icon16';
}
export const ArrowIcon = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "img",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_8, _9, _26, _27]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb1tcg _4t3i1tcg _1e0cglyw _w14j15vq _dm251ule", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ArrowIcon.displayName = 'ArrowIcon';
}
export const QueryContainer = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_28, _29, _30, _31, _32, _5, _7]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1reo15vq _18m915vq _zulpu2gc _1bto1l2s _o5721q9c _1e0c1txw _4cvr1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  QueryContainer.displayName = 'QueryContainer';
}
export const Query = forwardRef((_ref7, __cmplr) => {
  let {
      as: C = "button",
      style: __cmpls
    } = _ref7,
    __cmplp = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_10, _11, _12, _13, _14, _15, _33, _19, _5, _34, _35, _17, _7, _36, _37]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19itglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _11q7glyw _1yt4vc9x _80omtlke _1e0c1txw _1bah1yb4 _1bsb1osq _4t3ickbl _4cvr1h6o _x5dbugt7 _1yaguwho _165t1ylp _1wapewfl", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Query.displayName = 'Query';
}
export const SearchItemContainer = forwardRef((_ref8, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref8,
    __cmplp = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_5, _34, _35, _38, _39, _40, _20, _41, _42]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _1bah1yb4 _1bsb1osq _1ul9idpf _kqswh2mm _1lg6glyw _j6xt1dty _1vdzneh2 _wrkn166n _1rdt1ule _41ybewfl _fkkaewfl", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SearchItemContainer.displayName = 'SearchItemContainer';
}
export const SelectedMarker = forwardRef((_ref9, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref9,
    __cmplp = _objectWithoutProperties(_ref9, _excluded9);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_43, _44, _45, _46, _47, _48]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_11q71yqz _kqswstnw _1ltvidpf _154iidpf _94n5idpf _1bsbyh40", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SelectedMarker.displayName = 'SelectedMarker';
}
export const Text = forwardRef((_ref10, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref10,
    __cmplp = _objectWithoutProperties(_ref10, _excluded10);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_28, _29, _31, _32, _49, _50, _51, _52, _53, _54, _55]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1reo15vq _18m915vq _1bto1l2s _o5721q9c _syaz1fxt _k48p1nn1 _ect418aq _1wyb1j6v _zg8l4jg8 _vwz41k8s _1e0c1o8l", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Text.displayName = 'Text';
}
export const TextHighlighted = forwardRef((_ref11, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref11,
    __cmplp = _objectWithoutProperties(_ref11, _excluded11);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_55, _56, _50]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1o8l _syazaqb7 _k48p1nn1", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  TextHighlighted.displayName = 'TextHighlighted';
}